const actions = {
	GET_SUMMARIZE_WRITTEN_TEXT: 'GET_SUMMARIZE_WRITTEN_TEXT',
	GET_SUMMARIZE_WRITTEN_TEXT_SUCCESS: 'GET_SUMMARIZE_WRITTEN_TEXT_SUCCESS',

	CREATE_NEW_QUESTION_SUMMARIZE_WRITTEN_TEXT: 'CREATE_NEW_QUESTION_SUMMARIZE_WRITTEN_TEXT',
	CREATE_NEW_QUESTION_SUMMARIZE_WRITTEN_TEXT_SUCCESS: 'CREATE_NEW_QUESTION_SUMMARIZE_WRITTEN_TEXT_SUCCESS',

	DELETE_SUMMARIZE_WRITTEN_TEXT: 'DELETE_SUMMARIZE_WRITTEN_TEXT',
	DELETE_SUMMARIZE_WRITTEN_TEXT_SUCCESS: 'DELETE_SUMMARIZE_WRITTEN_TEXT_SUCCESS',

	GET_SUMMARIZE_WRITTEN_TEXT_DETAIL: 'GET_SUMMARIZE_WRITTEN_TEXT_DETAIL',
	GET_SUMMARIZE_WRITTEN_TEXT_DETAIL_SUCCESS: 'GET_SUMMARIZE_WRITTEN_TEXT_DETAIL_SUCCESS',

	UPDATE_SUMMARIZE_WRITTEN_TEXT_DETAIL: 'UPDATE_SUMMARIZE_WRITTEN_TEXT_DETAIL',
	UPDATE_SUMMARIZE_WRITTEN_TEXT_DETAIL_SUCCESS: 'UPDATE_SUMMARIZE_WRITTEN_TEXT_DETAIL_SUCCESS',

	WRITING_LOADING_FALSE: 'WRITING_LOADING_FALSE',
	//#region CRUD

	getSummarizeWrittenText: (model) => ({
		type: actions.GET_SUMMARIZE_WRITTEN_TEXT,
		payload: { model },
	}),

	createQuesSummarizeWrittenText: (model, cbSuccess, cbError) => ({
		type: actions.CREATE_NEW_QUESTION_SUMMARIZE_WRITTEN_TEXT,
		payload: { model },
		cbSuccess,
		cbError,
	}),

	getSummarizeWrittenTextDetail: (id) => ({
		type: actions.GET_SUMMARIZE_WRITTEN_TEXT_DETAIL,
		payload: { id },
	}),

	updateSummarizeWrittenTextDetail: (model, cbSuccess, cbError) => ({
		type: actions.UPDATE_SUMMARIZE_WRITTEN_TEXT_DETAIL,
		payload: { model },
		cbSuccess,
		cbError,
	}),

	deleteSummarizeWrittenText: (id, cbSuccess, cbError) => ({
		type: actions.DELETE_SUMMARIZE_WRITTEN_TEXT,
		payload: { id },
		cbSuccess,
		cbError,
	}),
};

export default actions;
